module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    attrs: {
      "id": 'view-' + _vm.name
    }
  }, [_c('background-video-player', {
    key: _vm.videoPlayerId,
    ref: _vm.videoPlayerId,
    attrs: {
      "videos": _vm.videoSource,
      "videoPlayerId": _vm.videoPlayerId
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "msg-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "pageTitle"
  }), _vm._v(" "), _c('hr', {
    staticClass: "titleSeparator"
  }), _vm._v(" "), _c('div', {
    staticClass: "msg"
  }, [(_vm.init) ? _c('text-content', {
    key: "msg3",
    attrs: {
      "lines": _vm.msg1,
      "delay": _vm.textDelay
    }
  }) : _c('text-content', {
    key: "msg4",
    attrs: {
      "lines": _vm.msg2,
      "delay": _vm.textDelay
    }
  })], 1), _vm._v(" "), (_vm.init) ? _c('cf-button', {
    key: 'view-' + _vm.name + '-continue',
    staticClass: "nav-btn btn-continue",
    attrs: {
      "width": 280,
      "id": 'view-' + _vm.name + '-continue',
      "content": 'Continue'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleClick($event)
      }
    }
  }) : _c('cf-button', {
    key: 'view-' + _vm.name + '-restart',
    staticClass: "nav-btn btn-continue",
    attrs: {
      "width": 280,
      "id": 'view-' + _vm.name + '-restart',
      "content": 'Restart',
      "animation": "",
      "to": {
        name: 'Home'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleClick($event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01cc02ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/result.vue
// module id = 218
// module chunks = 1